export const CREATE_INVESTMENT_ATTEMPT = 'CREATE_INVESTMENT_ATTEMPT';
export type CREATE_INVESTMENT_ATTEMPT = typeof CREATE_INVESTMENT_ATTEMPT;

export const CREATE_INVESTMENT_SUCCESS = 'CREATE_INVESTMENT_SUCCESS';
export type CREATE_INVESTMENT_SUCCESS = typeof CREATE_INVESTMENT_SUCCESS;

export const CREATE_INVESTMENT_FAILURE = 'CREATE_INVESTMENT_FAILURE';
export type CREATE_INVESTMENT_FAILURE = typeof CREATE_INVESTMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investment/create/Types.tsx